var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDiscord = function SvgDiscord(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 32,
    fill: "none",
    viewBox: "0 0 33 32"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    width: 33,
    height: 25,
    x: 0,
    y: 4,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M32.503 4.002h-32v24.774h32z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#5865F2",
    d: "M27.593 6.208a26.4 26.4 0 0 0-6.514-2.019.1.1 0 0 0-.104.05c-.282.5-.593 1.152-.811 1.665a24.4 24.4 0 0 0-7.316 0 17 17 0 0 0-.824-1.665.1.1 0 0 0-.104-.05 26.3 26.3 0 0 0-6.514 2.02.1.1 0 0 0-.042.036C1.215 12.439.079 18.481.636 24.448a.1.1 0 0 0 .042.075 26.5 26.5 0 0 0 7.99 4.036.1.1 0 0 0 .112-.036 19 19 0 0 0 1.635-2.658.1.1 0 0 0-.055-.14c-.87-.33-1.7-.733-2.497-1.19a.103.103 0 0 1-.01-.17c.168-.125.336-.256.496-.388a.1.1 0 0 1 .103-.014c5.237 2.39 10.907 2.39 16.082 0a.1.1 0 0 1 .105.013q.242.2.497.39a.103.103 0 0 1-.009.17 16.4 16.4 0 0 1-2.497 1.187.102.102 0 0 0-.055.142c.48.93 1.03 1.816 1.634 2.656.025.036.07.051.112.038a26.5 26.5 0 0 0 8.003-4.036.1.1 0 0 0 .042-.074c.667-6.898-1.118-12.89-4.732-18.203a.1.1 0 0 0-.041-.038M11.197 20.815c-1.577 0-2.876-1.447-2.876-3.224 0-1.776 1.274-3.223 2.876-3.223 1.615 0 2.901 1.46 2.876 3.223 0 1.777-1.274 3.224-2.876 3.224m10.633 0c-1.577 0-2.876-1.447-2.876-3.224 0-1.776 1.274-3.223 2.876-3.223 1.614 0 2.9 1.46 2.876 3.223 0 1.777-1.262 3.224-2.876 3.224"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.5 0h32v32H.5z"
  })))));
};
export default SvgDiscord;